export default __webpack_public_path__ + "static/media/confirm-app-tick-icon.013ef2b3.svg";